import { QueryColumn } from '@barthauer/abc/core/data';
import { GeoDsMeta } from './meta-data.model';

export class CommentModel extends GeoDsMeta {
  ParentId: string;
  ParentObjectType: string;
  SeqNr: number;
  Identifier: string;
  Text: string;
  Comment: string;
  constructor(data?: any) {
    super();

    if (data) {
      Object.assign(this, data);
    }
  }

  public static createQueryColumns(): Array<QueryColumn> {
    const queryColumns = super.createQueryColumns();
    queryColumns.push(
      {
        Name: 'InsertedDate',
        OPath: 'DateInsert',
      },
      {
        Name: 'UpdatedDate',
        OPath: 'DateUpdate',
      },
      {
        Name: 'ParentId',
        OPath: 'ParentId',
      },
      {
        Name: 'ParentObjectType',
        OPath: 'ParentObjectType',
      },
      {
        Name: 'SeqNr',
        OPath: 'SeqNr',
      },
      {
        Name: 'Identifier',
        OPath: 'Identifier',
      },
      {
        Name: 'Text',
        OPath: 'Text',
      },
      {
        Name: 'Comment',
        OPath: 'Comment',
        Format: 'Html',
      }
    );
    return queryColumns;
  }
}
